"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Definition of the CognitoUser model
 */

var MFAOption_1 = __importDefault(require("./MFAOption"));

var mixins_1 = require("@atlas/models/mixins");

var utils_1 = require("@atlas/models/utils");
/** Default values of enumerable properties */


var defaults = {
  username: '',
  firstName: '',
  lastName: '',
  privilegeLevel: '',
  createdAt: null,
  updatedAt: null,
  enabled: false,
  status: null,
  preferredMfaSetting: '',
  mfaOptions: [],
  userMfaSettingList: []
};
/** Represents a user retrieved from AWS cognito */

var User =
/** @class */
function () {
  /**
   * Creates a new CognitoUser
   * @param props Properties used to define the instance. When properties are not defined,
   * default values are used
   */
  function User(props) {
    if (props === void 0) {
      props = defaults;
    }
    /** Username */


    this.username = defaults.username;
    /** User's first name */

    this.firstName = defaults.firstName;
    /** User's last name */

    this.lastName = defaults.lastName;
    /** User's privilege level */

    this.privilegeLevel = defaults.privilegeLevel;
    /** Creation date of user */

    this.createdAt = defaults.createdAt;
    /** Date of last update to user */

    this.updatedAt = defaults.updatedAt;
    /** Indicates whether user is enabled */

    this.enabled = defaults.enabled;
    /** Indicates user's status */

    this.status = defaults.status;
    /** Indicates user's preferred MFA settings */

    this.preferredMfaSetting = defaults.preferredMfaSetting;
    /** User's MFA options */

    this.mfaOptions = defaults.mfaOptions;
    /** User's MFA settings */

    this.userMfaSettingList = defaults.userMfaSettingList;
    var username = props.username,
        firstName = props.firstName,
        lastName = props.lastName,
        privilegeLevel = props.privilegeLevel,
        createdAt = props.createdAt,
        updatedAt = props.updatedAt,
        enabled = props.enabled,
        status = props.status,
        preferredMfaSetting = props.preferredMfaSetting,
        mfaOptions = props.mfaOptions,
        userMfaSettingList = props.userMfaSettingList;
    this.username = username || defaults.username;
    this.firstName = firstName || defaults.firstName;
    this.lastName = lastName || defaults.lastName;
    this.privilegeLevel = privilegeLevel || defaults.privilegeLevel;
    this.createdAt = createdAt || defaults.createdAt;
    this.updatedAt = updatedAt || defaults.updatedAt;
    this.enabled = typeof enabled === 'boolean' ? enabled : defaults.enabled;
    this.status = status || defaults.status;
    this.preferredMfaSetting = preferredMfaSetting || defaults.preferredMfaSetting;
    this.mfaOptions = mfaOptions ? mfaOptions.map(function (mfaOption) {
      return mfaOption instanceof MFAOption_1.default ? mfaOption : new MFAOption_1.default(mfaOption);
    }) : defaults.mfaOptions;
    this.userMfaSettingList = userMfaSettingList || defaults.userMfaSettingList;
  }
  /**
   * Creates a CognitoUser from an object
   * @param obj The object to create from
   * @return A new CognitoUser instance
   */


  User.FromObject = function (obj) {
    return utils_1.parseObject(this, obj);
  };
  /**
   * Creates a CognitoUser from a response returned from the AWS SDK
   * @param resp The response used to create the user
   * @return A new CognitoUser instance
   */


  User.FromAdminGetUserResponse = function (resp) {
    var username = resp.Username,
        MFAOptions = resp.MFAOptions,
        userAttributes = resp.UserAttributes,
        enabled = resp.Enabled,
        createdAt = resp.UserCreateDate,
        updatedAt = resp.UserLastModifiedDate,
        status = resp.UserStatus,
        preferredMfaSetting = resp.PreferredMfaSetting,
        userMfaSettingList = resp.UserMFASettingList; // Parse user attributes to retrieve names and privilegeLevel

    var parsedAttributes = {
      firstName: defaults.firstName,
      lastName: defaults.lastName,
      privilegeLevel: defaults.privilegeLevel
    };

    if (userAttributes) {
      userAttributes.forEach(function (attr) {
        if (Object.hasOwnProperty.call(parsedAttributes, attr.Name)) {
          parsedAttributes[attr.Name] = attr.Value;
        }
      });
    }

    return new this(__assign(__assign({
      username: username
    }, parsedAttributes), {
      mfaOptions: MFAOptions && MFAOptions.map(function (opt) {
        return MFAOption_1.default.FromObject(opt);
      }),
      enabled: enabled,
      createdAt: createdAt,
      updatedAt: updatedAt,
      status: status,
      preferredMfaSetting: preferredMfaSetting,
      userMfaSettingList: userMfaSettingList
    }));
  };
  /** Default values of enumerable properties */


  User.DEFAULTS = defaults;
  return User;
}();

exports.User = User;
mixins_1.applyMixins(User, mixins_1.Objectable);
exports.default = User;